


// utility functions
(function () {
  // Your self-calling function code goes here
  function debounce(func, wait) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function toggleWishlist(override = false) {
    let config = {
      position: "bottom left",
      style: "sneakBlack",
      autoHideDelay: 7000,
    };
    
    if (window.matchMedia("(max-width: 768px)").matches) {
      config.position = "b center";
    }

    var zoomyPwishMsg = $(".zooomypwishmsg");
    if (zoomyPwishMsg[0]?.attributes?.style?.value?.includes("cursor") || override) {
      window.jQuery.notify("Saved", config);
    } else {
      window.jQuery.notify("Removed", config);
    }
   if ($("#signup-modal")) {
      $("#signup-modal")
        .css({
          display: "flex",
          opacity: 0,
          transform: "translateY(-20px)",
        })
        .animate(
          {
            opacity: 1,
            transform: "translateY(0)",
          },
          300
        );
      // Close Signup Popup when clicking outside of #signup-modal but inside of #signup-modal-container
      $(".modal-signup-modal-container").on("click", function (e) {
        if (e.target === this) {
          $("#signup-modal").animate(
            {
              opacity: 0,
              transform: "translateY(-20px)",
            },
            300,
            function () {
              $(this).css("display", "none");
              window.loginPopupResetState();
            }
          );
        }
      });
    }
  }

  function loginPopupResetState() {
    // Hide form fields
    const loginInner = document.querySelector('#login-inner');
    if(loginInner) {
      loginInner.classList.remove('show');
      loginInner.style = undefined;
      const signInSubmit = document.querySelector('#login-submit');
      if(signInSubmit) {
        signInSubmit.style = undefined;
      }
      const showSignIn = document.querySelector('#show-sign-in');
      if(showSignIn) {
        showSignIn.style = undefined;
      }
    }
    // Reset any error messages
    $("#signup-modal .error-message").hide();
    
    // Reset to initial view (if you have multiple steps/views)
    $("#signup-modal .login-view").show();
    $("#signup-modal .signup-view").hide();
    $('#register-form').hide(); // Hide register form
    $('#login-form').show(); // Show login form
  }

  window.clearFilterState = () => {
    window.clearAllFilter();
    const tagLabels = document.querySelectorAll('.product-tags[data-product-id]');
  
    if(tagLabels) {
      tagLabels.forEach(label => {
      const input = document.getElementById(label.htmlFor);
      setTimeout(() => input.checked = false, 0);
    });
    }
  }

  window.debounceFunc = debounce;
  window.toggleWishlist = toggleWishlist;
  window.loginPopupResetState = loginPopupResetState;
})();

// things to run once page is loaded
document.addEventListener("DOMContentLoaded", function () {
    // style for dialog/modal
    window.jQuery.notify.addStyle("sneakBlack", {
      html: "<div class='notifyjs-foo-base'><span data-notify-text/></div>",
      classes: {
        base: {
          "white-space": "nowrap",
          "background-color": "#fff",
          zIndex: "90000",
          padding: "10px",
          color: "#000",
          "font-size": "12px",
          "border-radius": "5px",
          "margin-right": "10px",
        },
      },
    });

    window.jQuery(document).on('click', '.notifyjs-container', function() {
      window.document.location = 'https://www.sneakinpeace.com/pages/wishlist';
    });
    
    const wishlistFunc = window.debounceFunc(function(override = false) {
      window.toggleWishlist(override);
    }, 100)

    $("body").on("click",".zoomywishidheart",function(o){
      const isSelected = o.currentTarget.querySelector('.fa-bookmark-o') !== null;
      wishlistFunc(isSelected);
    });
  });